/* eslint-disable @nx/enforce-module-boundaries */
import { FollowIcon, HandShakeSimpleIcon, ManageTestimonialIcon } from '@mybridge/icons';
import NextLink from 'next/link';
import {
  Box,
  Button,
  Card,
  Divider,
  HStack,
  Heading,
  Link,
  Stack,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  VStack,
  Scrollable,
  Text,
} from '@mybridge/ui';
import { forwardRef, useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { MyNetworkContext } from 'v4/components/network/context';
import { MyProfileActivity } from 'v4/components/public-profile/activity';
import { MyProfileCauses } from 'v4/components/public-profile/causes';
import { MyProfileCertificate } from 'v4/components/public-profile/certificates';
import { MyProfileConnectionsList } from 'v4/components/public-profile/connections-list';
import { PublicProfileContext } from 'v4/components/public-profile/context';
import { MyProfileDegreeConnections } from 'v4/components/public-profile/degree-connections';
import { MyProfileEducation } from 'v4/components/public-profile/education';
import { MyProfileExperience } from 'v4/components/public-profile/experience';
import { MyProfileInterests } from 'v4/components/public-profile/interests';
import { MyProfileIntroduction } from 'v4/components/public-profile/introduction';
import { MyProfileMilestone } from 'v4/components/public-profile/milestones';
import { MyProfilePersonalInfo } from 'v4/components/public-profile/personal-info';
import { MyProfileSkills } from 'v4/components/public-profile/skills';
import { MyProfileNetworkSuggestionsList } from 'v4/components/public-profile/suggestions-list';
import { MyProfileTestimonial } from 'v4/components/public-profile/testimonials';
import { getUserFullName } from 'v4/lib/commons';
import ProfilePublicSidebar from './sidebar';
import { isMobile } from 'react-device-detect';

export const ProfilePublicView = forwardRef(({ slug, ...props }, ref) => {
  const {
    skills,
    education,
    experiences,
    milestones,
    certificates,
    hasPersonalInfo,
    hasIntro,
    testimonials,
    loggedIn,
    publicProfile,
  } = useContext(PublicProfileContext);
  const { isFriend, refetchSuggestions } = useContext(MyNetworkContext);

  useEffect(() => {
    if (!loggedIn) return;
    refetchSuggestions?.();
  }, [loggedIn]);

  const handleClickScroll = (id) => {
    const element = document.getElementById(id);
    const headerOffset = 190;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  };
  return (
    <>
      <Card variant="thinBorderedCard">
        <HStack align="stretch">
          <VStack align="stretch" maxW={["100%"]} gap={10} p={3}>
            {hasIntro && (
              <Box id="introsection">
                <MyProfileIntroduction />
              </Box>
            )}
            {hasPersonalInfo && (
              <Box id="profileInfo">
                <MyProfilePersonalInfo />
              </Box>
            )}
            {experiences?.length > 0 && (
              <Box id="profileExperience">
                <MyProfileExperience />
              </Box>
            )}
            {education?.length > 0 && (
              <Box id="profileEducation">
                <MyProfileEducation />
              </Box>
            )}
            {skills?.length > 0 && (
              <Box id="profileSkills">
                <MyProfileSkills />
              </Box>
            )}
            {milestones?.length > 0 && (
              <Box id="profileMilestone">
                <MyProfileMilestone />
              </Box>
            )}
            {certificates?.length > 0 && (
              <Box id="profileCerts">
                <MyProfileCertificate />
              </Box>
            )}
            {testimonials?.length > 0 && (
              <Box id="profileTestimonials">
                <MyProfileTestimonial />
              </Box>
            )}
            {isMobile && isFriend?.(publicProfile) && (
              <Card p={3} variant="thinBorderedCard">
                <Text mb={3} fontSize="14px" color="#868585">
                  Give or Ask {publicProfile?.display_name} for testimonial
                </Text>
                <NextLink href="/profile/testimonials">
                  <Button
                    leftIcon={<ManageTestimonialIcon />}
                    variant="secondary"
                    color="#868585"
                    size="lg"
                    maxW="fit-content"
                  >
                    Manage testimonial
                  </Button>
                </NextLink>
              </Card>
            )}
          </VStack>
        </HStack>
      </Card>
    </>
  );
});